import { SortingIcon, StyledHeaderSorting } from './styles'
import { mdiArrowDown, mdiArrowUp } from '@mdi/js'

interface HeaderSortingProps {
  isSorted: boolean
  isSortedDesc: boolean | undefined
}

function HeaderSorting({ isSorted, isSortedDesc }: HeaderSortingProps) {
  return (
    <StyledHeaderSorting>
      {isSorted ? (
        <SortingIcon path={isSortedDesc ? mdiArrowDown : mdiArrowUp} />
      ) : null}
    </StyledHeaderSorting>
  )
}

export default HeaderSorting
